<template>
	<el-row class="points-show">
		<el-col :span="24">
			<el-col :span="10">用户管理</el-col>
			<el-col :span="4" :offset="10">
				<el-button type="primary" size="mini" style="margin-left: 30px" @click="addUser(1)" plain>
					添加用户<i class="el-icon-add"></i>
				</el-button>
			</el-col>
		</el-col>
		<el-divider></el-divider>
		<el-col :span="24">
			<el-table :data="userList" :height="tableHeight" style="width: 100%">
				<el-table-column width="180" prop="id" label="用户id">
				</el-table-column>
				<el-table-column prop="userName" label="用户名称">
				</el-table-column>
				<el-table-column label="用户状态">
					<template slot-scope="scope">
						<!-- :disabled="scope.row.parentId != -1" -->
						<el-switch style="display: block" v-model="scope.row.status == 0" active-color="#13ce66"
							inactive-color="#ff4949" active-text="启用" inactive-text="禁用"
							@change="cantShow(scope.row.userName, scope.row.id, scope.row.status)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column width="280" label="创建时间">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime | formatDate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" @click="Assignment(scope.row)">
							角色分配
						</el-button>
						<el-button size="mini" @click="addUser(2,scope.row)">
							编辑
						</el-button>
						<el-button size="mini" type="danger" @click="delUser(scope.row.id)">
							移除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="pageSizes">
			</el-pagination>
		</el-col>
		<el-col>
			<el-dialog :title="editStatus == 1?'添加用户':'编辑用户'" :visible.sync="dialogVisible" :before-close="closeUpdate"
				width="30%">

				<!-- 新增用户-->
				<template v-if="editStatus == 1">
					<el-form :model="addUserform" label-position="right" label-width="120px">
						<el-form-item label="用户名称:">
							<el-input size="mini" :rows="5" placeholder="请输入用户名称" v-model="addUserform.userName">
							</el-input>
						</el-form-item>
						<el-form-item label="用户密码:">
							<el-input size="mini" :rows="5" placeholder="请输入用户密码" show-password
								v-model="addUserform.password" />
						</el-form-item>
						<el-form-item label="用户商城id:">
							<el-input size="mini" :rows="5" placeholder="请输入用户商城id" v-model="addUserform.memberId" />
						</el-form-item>
						<el-form-item label="用户状态:">
							<el-radio-group v-model="addUserform.status">
								<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
									{{ item.title }}
								</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form>
				</template>

				<!-- 修改用户-->
				<template v-if="editStatus == 2">
					<el-form :model="editUserform" label-position="right" label-width="120px">
						<el-form-item label="用户名称:">
							<el-input size="mini" :rows="5" placeholder="请输入用户名称" v-model="editUserform.userName">
							</el-input>
						</el-form-item>
						<el-form-item label="用户密码:">
							<el-input size="mini" :rows="5" show-password placeholder="请输入用户密码"
								v-model="editUserform.password" />
						</el-form-item>
						<el-form-item label="用户商城id:">
							<el-input size="mini" :rows="5" placeholder="请输入用户商城id" v-model="editUserform.memberId" />
						</el-form-item>
						<el-form-item label="用户状态:">
							<el-radio-group v-model="editUserform.status">
								<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
									{{ item.title }}
								</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-form>
				</template>

				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click="closeUpdate">取 消</el-button>
					<el-button size="mini" type="primary" @click="determine()">确 定</el-button>
				</div>
			</el-dialog>
			<el-dialog title="角色分配" :visible.sync="dialogRoleVisible" :before-close="closeUpdate" width="30%">

				<!-- 角色分配-->
				<el-form :model="editRoleform" label-position="right" label-width="120px">
					<el-form-item label="用户名称:">
						<el-input size="mini" :rows="5" disabled placeholder="请输入用户名称" v-model="editRoleform.userName">
						</el-input>
					</el-form-item>
					<el-form-item label="角色权限:">
						<div class="scroll-view">
							<div v-for="(item,index) in roleList" :key="index">
								<el-checkbox v-model="item.checked">{{item.roleName}}</el-checkbox>
							</div>
						</div>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click="closeUpdate">取 消</el-button>
					<el-button size="mini" type="primary" @click="determineRole()">确 定</el-button>
				</div>
			</el-dialog>
		</el-col>
	</el-row>
</template>

<script>
	var vm;
	export default {
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 30, 40, 50],
				total: 0,
				editStatus: -1,
				dialogRoleVisible: false,
				dialogVisible: false,
				tableHeight: window.innerHeight - 300,
				userList: [],
				addUserform: {
					userName: '',
					password: '',
					status: -1,
					memberId: ''
				},
				editUserform: {
					id: '',
					userName: '',
					password: '',
					status: -1,
					memberId: ''
				},
				editRoleform: {
					id: '',
					userName: '',
					roleList: []
				},
				reviewStatus: [{
						title: "启用",
						type: 0,
					},
					{
						title: "禁用",
						type: 1,
					},
				],
				roleList: []
			};
		},
		created() {
			vm = this;
			this.getUserList();
		},
		filters: {
			// 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format("YYYY-MM-DD HH:MM:SS") : "";
			},
		},
		methods: {
			//获取角色列表
			getUserList() {
				this.$http
					.post(`/api/source/sysUser/select?pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {
						deleteStatus: 0,
					})
					.then((res) => {
						if (res.data.status == 0) {
							console.log(res.data.data.result, "用户列表");
							this.userList = res.data.data.result.list
							this.total = res.data.data.result.total
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			//添加角色
			addUser(type, val) {
				this.editStatus = type
				if (type == 2) {
					this.editUserform.id = val.id
					this.editUserform.userName = val.userName
					this.editUserform.password = val.password
					this.editUserform.status = val.status
					this.editUserform.memberId = val.memberId
				}
				this.dialogVisible = true
			},

			cantShow(userName, id, status) {
				status = status == 0 ? 1 : 0;
				this.$http
					.get(`/api/source/sysUser/upodateStatus/${id}/${status}`, {})
					.then((res) => {
						if (res.data.status == 0) {
							var statusText = status != 0 ? "禁用" : "启用";
							if (status != 0) {
								this.$message.error(userName + "已" + statusText);
							} else {
								this.$message.success(userName + "已" + statusText);
							}
							this.getUserList();
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
			},
			//角色分配
			Assignment(userInfo) {
				this.editRoleform.id = userInfo.id
				this.editRoleform.userName = userInfo.userName
				var data = {
					status: 0,
					deleteStatus: 0,
					userId: userInfo.id,
				}
				this.$http
					.post(`/api/source/sysRole/selectayuan`, data)
					.then(res => {
						if (res.data.status == 0) {
							console.log(res.data.data, '用户权限分配');
							this.roleList = res.data.data
							this.dialogRoleVisible = true
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					})
			},
			//关闭弹窗
			closeUpdate() {
				this.addUserform = {
						userName: '',
						password: '',
						status: -1,
						memberId: ''
					},
					this.editUserform = {
						id: '',
						userName: '',
						password: '',
						status: -1,
						memberId: ''
					},
					this.editStatus = -1,
					this.editRoleform = {
						id: '',
						userName: '',
						roleList: []
					},
					this.dialogRoleVisible = false
				this.dialogVisible = false

			},
			//角色分配 确定
			determineRole() {
				var list = this._.filter(this.roleList, ['checked', true])
				console.log(list);
				var data = []
				list.forEach(item => {
					data.push({
						roleId: item.id
					})
				})

				this.$http
					.post(`/api/source/sysUser/settingRole/${this.editRoleform.id}`, data)
					.then(res => {
						if (res.data.status == 0) {
							this.$message.success("数据更新成功！！");

						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
						this.closeUpdate() //关闭弹窗
					})
			},
			//添加/编辑用户  确定按钮
			determine() {
				let _this = this;
				//添加
				if (this.editStatus == 1) {
					if (
						!this.addUserform.userName.trim() ||
						!this.addUserform.password.trim() ||
						this.addUserform.status < 0
					) {
						return this.$message({
							type: "error",
							message: "请填写完整用户信息再提交~~",
						});
					}
					var data = {
						...this.addUserform,
						deleteStatus: 0
					};

					this.$http
						.post(`/api/source/sysUser/insert`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加用户信息成功！！",
								});
								_this.getUserList();
								_this.closeUpdate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.editStatus == 2) {
					var data = {
						...this.editUserform
					};

					this.$http
						.post(`/api/source/sysUser/update`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改用户信息成功！！",
								});
								_this.getUserList();
								_this.closeUpdate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},
			//删除用户
			delUser(id) {
				this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysUser/deleteById/${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getUserList()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getUserList();
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getUserList();
			},
		},
	};
</script>

<style scoped lang="less">
	.scroll-view {
		max-height: 260px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin: 10px;
	}

	.scroll-view::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 2px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #66b8ff;
	}

	.scroll-view::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
		background: #ededed;
	}

	.text {
		font-size: 14px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both
	}

	.box-card {
		width: 480px;
	}

	/deep/.el-input {
		width: 80%;
		height: auto;
	}
</style>
